// extracted by mini-css-extract-plugin
module.exports = {"backSVGContainer":"BackgroundSVG_backSVGContainer__3xyyC"};